import React from 'react';

import {
  BrowserRouter, Routes,
  Route,
  Navigate,
  Outlet,
} from 'react-router-dom';
import { connect } from 'react-redux'
import { init } from './redux/actions/serverManagerAction'
import PropTypes from 'prop-types';
import Header from './components/Base/Header'
import Footer from './components/Base/Footer';
import Factures from './components/Factures/Factures';
import Cartes from './components/Cartes/Cartes'
import Consommations from './components/Consommations/Consommations';
import Login from './components/Login/Login'
import Home from './components/Home/Home';
//import useToken from './Hooks/useToken'
import 'bootstrap/dist/css/bootstrap.min.css';
import Ticpe from './components/Ticpe/Ticpe';


import FunctionContainer from './components/Base/FunctionContainer';

import PasswordLost from './components/Login/PasswordLost';
import ResetPassword from './components/Login/ResetPassword';

import Badges from './components/Badges/Badges';
import Adresses from './components/Adresses/Adresses';
import Contacts from './components/Contacts/Contacts';
import ModesPaiements from './components/ModesPaiements/ModesPaiements';
import Password from './components/Password/Password';
import Avantages from './components/Avantages/Avantages';

import { Spinner } from 'react-bootstrap';
import { setHomeInfo } from './redux/actions/appActions';
import { fetchServer } from './components/Base/modelManager';
import { message } from 'antd';



const ProtectedRoute = ({
  isAllowed,
  redirectPath = '/Login',
  children,
}) => {
  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
};


class App extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      configLoaded: false,
      windowSize: window.innerHeight
    }




  }







  componentDidMount() {


    const { dispatch } = this.props;
    dispatch(init())

  }

  componentDidUpdate(prevprops){
    if (prevprops.currentClient!==this.props.currentClient && this.props.currentClient!==undefined) {
      this.getHomeInfo()
    }

  }

  getHomeInfo = () => {
    const { currentClient,dispatch } = this.props


    const request = {
      endPoint: this.props.apiUrl + '/Services/homeInfo?clientid=' + currentClient.uid,
      method: 'GET',
      token: this.props.JWTToken
    }

    fetchServer(request,
      (json) => {
        dispatch(setHomeInfo(json))
      },
      error => message.error(error)
    )
  }


  render() {


    if (!this.props.serverConfigLoaded) {
      return <Spinner />
    }
    /*
        if (!this.props.authorized) {
          return <Login />
        }
        */

    return (

      <BrowserRouter>

        <Header />





        <main id="main">


          {/*      <div className="site-layout-content" style={{ height: this.height }}>*/}


          <Routes>
            <Route path='/Login' element={<FunctionContainer title='Login' Content={<Login />} public={true} />} />
            <Route path='/' element={
              <ProtectedRoute
                redirectPath="/Login"
                isAllowed={this.props.authorized}>

                <FunctionContainer title='Home' Content={<Home />} />
              </ProtectedRoute>}
            />

            <Route path="/Factures" element={<ProtectedRoute
              redirectPath="/Login"
              isAllowed={this.props.authorized}><FunctionContainer title='Factures' Content={<Factures />} />
            </ProtectedRoute>}

            />

            <Route path="/Cards" element={<ProtectedRoute
              redirectPath="/Login"
              isAllowed={this.props.authorized}><FunctionContainer title='Cartes' Content={<Cartes />} />
            </ProtectedRoute>}
            />

            <Route path="/Badges" element={<ProtectedRoute
              redirectPath="/Login"
              isAllowed={this.props.authorized}><FunctionContainer title='Badges' Content={<Badges />} />
            </ProtectedRoute>}
            />

            <Route path="/Consommation" element={<ProtectedRoute
              redirectPath="/Login"
              isAllowed={this.props.authorized}><FunctionContainer title='Consommations' Content={<Consommations />} />
            </ProtectedRoute>}
            />

            <Route path="/Ticpe" element={<ProtectedRoute
              redirectPath="/Login"
              isAllowed={this.props.authorized}><FunctionContainer title='Ticpe' Content={<Ticpe />} />
            </ProtectedRoute>}
            />
            <Route path="/Adresses" element={<ProtectedRoute
              redirectPath="/Login"
              isAllowed={this.props.authorized}><FunctionContainer title='Adresses' Content={<Adresses />} />
            </ProtectedRoute>}
            />
            <Route path="/Contacts" element={<ProtectedRoute
              redirectPath="/Login"
              isAllowed={this.props.authorized}><FunctionContainer title='Contacts' Content={<Contacts />} />
            </ProtectedRoute>}
            />
            <Route path="/ModesPaiements" element={<ProtectedRoute
              redirectPath="/Login"
              isAllowed={this.props.authorized}><FunctionContainer title='ModesPaiements' Content={<ModesPaiements />} />

            </ProtectedRoute>}
            />
            <Route path="/Password" element={<ProtectedRoute
              redirectPath="/Login"
              isAllowed={this.props.authorized}><FunctionContainer title='Password' Content={<Password />} />
            </ProtectedRoute>}
            />
            <Route path="/Avantage" element={<ProtectedRoute
              redirectPath="/Login"
              isAllowed={this.props.authorized}><FunctionContainer title='Avantage' Content={<Avantages />} />
            </ProtectedRoute>}
            />

            <Route path="/Password" element={<ProtectedRoute
              redirectPath="/Login"
              isAllowed={this.props.authorized}><FunctionContainer title='Password' Content={<Password />} />
            </ProtectedRoute>}
            />

            <Route path='/PasswordLost' element={<FunctionContainer title='Mot de passe Oublié' Content={<PasswordLost />} public={true} />} />
            <Route path='/ResetPassword' element={<FunctionContainer title='Reset Mot de passe' Content={<ResetPassword />} public={true} />} />

          </Routes>

          {/*   </div>*/}

        </main>
        <Footer />


      </BrowserRouter>


    );
  }
}




const mapStateToProps = (state) => {

  return ({
    serverConfigLoaded: state.server.initialized,
    authorized: state.authentication.authorized,
    clients: state.authentication.clients,
    currentClient: state.authentication.currentClient,
    contentHeight: state.app.contentHeight,
    apiUrl: state.server.apiUrl,
    JWTToken:state.authentication.JWTToken
  })
}

App.propTypes = {
  dispatch: PropTypes.func,
  location: PropTypes.object,
  authorized: PropTypes.bool,
  serverConfigLoaded: PropTypes.bool,
  clients: PropTypes.array,
  currentClient: PropTypes.object,
  contentHeight: PropTypes.number
};

export default connect(mapStateToProps)(App);
